import { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Field,
  Input,
  MessageBar,
  Text,
} from "@fluentui/react-components";
import i18n from "i18next";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";
import { StackShim } from "@fluentui/react-migration-v8-v9";

interface IUserMediaDeleteDialogProps {
  userMediaGuid: string | undefined;
  onDismiss(): void;
  onDelete(): void;
}

function UserMediaDeleteDialog(props: IUserMediaDeleteDialogProps) {
  const [deleteError, setDeleteError] = useState("");
  const [deleteDto, setDeleteDto] = useState<any>();

  const deleteUserMedia = (id: string) => {
    setDeleteError("");
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/UserMedia/Delete?id=${id}`)
      .then((result) => {
        setDeleteDto(result);
      });
  };

  const deleteUserMediaConfirmed = () => {
    fetchWrapper
      .postWithAuth(`${baseUrl}/api/UserMedia/DeleteConfirmed`, deleteDto)
      .then((result) => {
        setDeleteDto(undefined);
        props.onDelete();
      })
      .catch((error) => {
        setDeleteError(error);
      });
  };

  useEffect(() => {
    if (props.userMediaGuid) {
      deleteUserMedia(props.userMediaGuid);
    }
  }, [props.userMediaGuid]);

  return (
    <Dialog modalType="modal" open={props.userMediaGuid != undefined}>
      <DialogTrigger disableButtonEnhancement></DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>{i18n.t<string>("deleteDocument")}</div>

              <Button
                onClick={() => {
                  props.onDismiss();
                }}
                appearance="transparent"
                icon={<Dismiss24Regular />}
              ></Button>
            </div>
          </DialogTitle>
          <DialogContent>
            <StackShim tokens={{ childrenGap: 10 }}>
              <Text>
                {i18n
                  .t("deleteDocumentText")
                  .replace(
                    "{name}",
                    deleteDto ? `'${deleteDto.description}'` : ""
                  )}
              </Text>

              {deleteError != "" && (
                <MessageBar className="lueb-MarginTop10" intent="error">
                  {i18n.t<string>(deleteError)}
                </MessageBar>
              )}
            </StackShim>
          </DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              onClick={() => deleteUserMediaConfirmed()}
            >
              {i18n.t<string>("delete")}
            </Button>

            <Button
              appearance="secondary"
              onClick={() => {
                setDeleteDto(undefined);
                props.onDismiss();
              }}
            >
              {i18n.t("cancel")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
export default UserMediaDeleteDialog;
